import styled from 'styled-components'
import { stylevars } from '@Common/StyleVars'

export const CollectionsModalContainer = styled('div')`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${stylevars.paper.bodyColor};
`